
import { FormStructure } from "../../types/form";
import { page1Config } from "./page1";
import { page2Config } from "./page2";
import { page3Config } from "./page3";
import { page4Config } from "./page4";

export const formConfig: FormStructure = [
  page1Config,
  page2Config,
  page3Config,
  page4Config
];

export { page2Config } from "./page2";
